var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6056 23.9999L17.5096 17.0079L21.0936 12.6079H19.6056L14.2936 19.1519V12.6079H13.0776V23.9999H14.2936V20.8159L16.6936 17.9359L20.1656 23.9999H21.6056Z",
    fill: "#FFD4A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5239 16.7679C27.9639 16.2079 27.3879 16.0319 26.6359 16.0319C25.7239 16.0319 24.8599 16.4319 24.4279 17.0879V16.1279H23.2759V23.9999H24.4279V19.1679C24.4279 17.9679 25.1639 17.0559 26.3159 17.0559C26.9239 17.0559 27.2439 17.1999 27.6759 17.6319L28.5239 16.7679Z",
    fill: "#FFD4A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 34.3333C28.1698 34.3333 35.3333 27.1698 35.3333 18.3333C35.3333 9.4967 28.1698 2.33325 19.3333 2.33325C10.4967 2.33325 3.33325 9.4967 3.33325 18.3333C3.33325 27.1698 10.4967 34.3333 19.3333 34.3333Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCost);
export default __webpack_public_path__ + "static/media/ico_cost.da9a2a983929366b372d92b820dd6b38.svg";
export { ForwardRef as ReactComponent };